export const formatISODate = (str = '') => {
  const dateRegexPattern = /^(\d{4})\-(\d{2})\-(\d{2})$/;
  let returnStr = str || '';
  returnStr = returnStr.replaceAll('\/', '-');
  const match = returnStr.match(dateRegexPattern);
  if (match) {
    return match[2] + '/' + match[3] + '/' + match[1]
  }
  return str;
};


const formatDate = (str = '') => {
  let returnStr = '';
  const input = str.replace(/\D/g, '').substring(0, 8); // First eight digits of input only
  const month = input.substring(0, 2);
  const day = input.substring(2, 4);
  const year = input.substring(4, 8);
  if (input.length > 4) {
    returnStr = `${month}/${day}/${year}`;
  } else if (input.length > 2) {
    returnStr = `${month}/${day}`;
  } else if (input.length > 0) {
    returnStr = `${month}`;
  }
  return returnStr;
};

export default formatDate;
